<template>
    <!-- Foto de la conversación o, si no hay (o no carga), la inicial sobre el
         degradé de marca: igual que el círculo del header. -->
    <span :class="['bk-ava', { 'bk-ava--lg': grande }]" aria-hidden="true">
        <img v-if="src && !rota" :src="src" alt="" loading="lazy" @error="rota = true">
        <template v-else>{{ inicial }}</template>
    </span>
</template>

<script>
export default {
    name: 'BkAvatar',
    props: {
        src: { type: String, default: '' },
        nombre: { type: String, default: '' },
        grande: { type: Boolean, default: false },
    },
    data() {
        return { rota: false };
    },
    computed: {
        inicial() {
            const palabras = String(this.nombre || '').trim().split(/\s+/).filter(w => /[\p{L}\d]/u.test(w));
            const ini = palabras.slice(0, 2).map(w => w.match(/[\p{L}\d]/u)[0]).join('');
            return (ini || '?').toUpperCase();
        },
    },
    watch: {
        src() { this.rota = false; },
    },
};
</script>

<style>
.bk-ava {
    display: grid; place-items: center; flex: none; overflow: hidden;
    width: 52px; height: 52px; border-radius: 50%;
    background: linear-gradient(180deg, #ff8414, #f26b05);
    color: #fff; font-size: 18px; font-weight: 700; letter-spacing: -.01em;
    box-shadow: 0 0 0 2px #fff, 0 6px 14px -8px rgba(232, 100, 10, .6);
}
.bk-ava img { width: 100%; height: 100%; object-fit: cover; }
.bk-ava--lg { width: 56px; height: 56px; font-size: 20px; }
</style>
